import React, { useState, useEffect } from "react";
import { rbac } from "../index";
import t from "../../../helpers/t";

import { voucherTypesActions, vouchersActions, useSelector } from "inbooma-api"; // necessary to communicate with inbooma-react api
import { Biscuit } from "../../../../utils"; // necessary to communicate with inbooma-react
import { _, $, moment } from "../../../../../vendor";

import de from "date-fns/locale/de";
import DatePicker from "react-datepicker";
import { getDocHandler } from "../../../../utils/Helper";
import fr from "date-fns/locale/fr";
import en from "date-fns/locale/en-GB";
import MembershipTypeSelect from "../../users/components/MembershipTypeSelect";
import TimeInput from "../../../components/timeinput";

const ItemLoginView = (props) => {
  const {
    dispatch,
    filterChangedHandle,
    filter,
    showNotification,
    requestPath,
    voucherLogin,
    setIndex,
    setAdd,
    setVoucherLogin,
    setVouchersPending,
  } = props;
  const emptyGenerateVoucherLogin = {
    usergroups: null,
    validPeriod: null,
    validFrom: "",
  };
  /*
    const emptyVoucherLogin = {
      id: null,
      user_id: null,
      username: "",
      validTo: "",
      valid: false
    };*/

  const [localVoucherLogin, setLocalVoucherLogin] = useState(
    typeof voucherLogin.user_id === "undefined" ? emptyGenerateVoucherLogin : voucherLogin,
  );

  let language = Biscuit.get("user.lang").replace("-", "_");
  const [timeInput, setTimeInput] = useState(86400 * 3);
  const [selectedBegin, setSelectedBegin] = useState(new Date());
  const dateLocale =
    Biscuit.get("user.lang").indexOf("de") >= 0
      ? de
      : Biscuit.get("user.lang").indexOf("fr") >= 0
        ? fr
        : en;
  const uuid = _.uniqueId; // init, saving
  const _patchVoucherLogin = useSelector((state) => state.voucher_types_data.editVoucherLogin); // used for after save process
  const _postVoucherLogin = useSelector((state) => state.voucher_types_data.generateVoucherLogin); // used for after save process
  const [selectedUserGroups, setSelectedUserGroups] = useState([]);
  const [voucherLoginPending, setVoucherLoginPending] = useState(false);

  const [initialized, setInitialized] = useState(false);

  const onGetQRCodeHandler = () => {
    const url = "/users/generateVoucherLogin/" + uuid() + Date.now().toString();
    const method = "POST";
    const id = null;
    const type = "image/png";
    const filename = "Gutschein Temporärer Login.png";
    const userGroups = {
      usergroups: selectedUserGroups,
      validPeriod: timeInput !== null ? timeInput : null,
      validFrom: moment(selectedBegin).format("DD.MM.YYYY HH:mm:ss"),
    };
    getDocHandler(url, method, type, filename, "", null, JSON.stringify(userGroups));
    close();
    /*const xmlHttp = new XMLHttpRequest();

        xmlHttp.open("POST", getApiHost() + '/users/generateVoucherLogin', true,);

        xmlHttp.setRequestHeader('Accept', 'application/json');
        xmlHttp.setRequestHeader('Authorization', 'Bearer ' + Biscuit.get('token'));
        xmlHttp.responseType = 'blob';

        xmlHttp.onload = function () {
            // do something to response
            const blob = new Blob([xmlHttp.response], { type: 'image/png' });

            FileSaver.saveAs(blob, "Gutschein Temporärer Login.png");
        };
        xmlHttp.send(JSON.stringify(userGroups));
        xmlHttp.onerror = function () {
            /!*
            new Notification({
                message: that.t('orders_sales_billings_error'),
                duration: 6000,
                type: 'warning',
                closeable: true,
                icon: 'fi fi-x'
            });
            let images = document.getElementsByClassName('rollingLoader');

            _.each(images, (image) => {
                image.parentNode.removeChild(image);
            });
            *!/
        };*/
  };

  const currentUrl = new URL(window.location.href);
  const close = () => {
    dispatch(voucherTypesActions.getVoucherTypesResetData());
    let requestPath = "";

    let currentURL = "";
    let returnUrl = requestPath !== "" ? requestPath + currentURL : `/vouchers${currentURL}`;
    console.log("returnUrl", returnUrl);
    window.location.replace(returnUrl);

    //props.setIndex(null);
    /* props.setResource([]);
        props.setIndex(null);
        //setToggleItemView(false);
        props.setAdd(false);
        alert('set Resource Changed');
        props.setResourcesPending(true);
        props.filterChangedHandle(props.filter);*/
    // props.onClose();
  };
  const onChange = (e, name) => {
    setTimeInput(e);
  };

  const onChangeForm = (e) => {
    let clone = {};
    Object.assign(clone, voucherLogin);
    switch (e.target.name) {
      case "name":
        clone.name = e.target.value;
        break;
      case "status":
        clone.status = e.target.checked;
        break;
      case "description":
        clone.description = e.target.value;
        break;
      case "voucher_value":
        clone.voucher_value = e.target.value;
        break;
      case "contingent_number":
        clone.contingent_number = e.target.value;
        break;
      case "multiple_use":
        clone.multiple_use = e.target.checked;
        break;
      case "sellable":
        clone.mac = e.target.checked;
        break;
      case "days_number":
        clone.days_number = e.target.value;
        break;
    }
    setVoucherLogin(clone); // set object state
  };

  const abortButtonRef = React.createRef();
  let returnUrl =
    typeof props.requestPath !== "undefined"
      ? props.requestPath + currentUrl.search + currentUrl.search
      : `/vouchers${currentUrl.search}`;

  const onSubmit = () => {};
  return (
    <>
      <div className="js-off-canvas-overlay is-overlay-fixed is-visible"></div>

      {rbac.hasPermission("editVoucher") && (
        <div
          className="off-canvas position-right is-transition-overlap is-open"
          id="inb-off-canvas"
          data-off-canvas="85mrb3-off-canvas"
          data-close-on-click="true"
          aria-hidden="false"
        >
          <header className="inb-header off-canvas__header off-canvas--shadow clearfix row">
            <h1 className="inb-page-title">
              {typeof localVoucherLogin.id !== "undefined"
                ? t("edit_${a}", { a: t("voucher", null, "capital") })
                : t("add_${a}", { a: t("voucher", null, "capital") })}
            </h1>
            <div className="off-canvas__actions column">
              <button
                type="submit"
                className={
                  "button medium beautify beautify-" +
                  Biscuit.get("user.client_id") +
                  " button-submit round"
                }
                title="Speichern"
                onClick={onSubmit}
              >
                {!voucherLoginPending && typeof localVoucherLogin.id !== "undefined" ? (
                  <>
                    <i className="fi fi-check"></i>
                    <span>{t("save")}</span>
                  </>
                ) : (
                  <>
                    {typeof localVoucherLogin.id !== "undefined" && (
                      <>
                        <span>
                          <img className="rollingLoader" src="assets/img/rolling_loader.svg" />
                          {t("save")}
                        </span>
                      </>
                    )}
                  </>
                )}
              </button>
              <a href="#">
                <button
                  ref={abortButtonRef}
                  type="button"
                  id="inb-resourcesform-abort-button"
                  className="button hollow secondary right button-abort round"
                  title="Fenster schließen"
                  onClick={() => close()}
                >
                  <i className="fi fi-x"> </i>
                </button>
              </a>
            </div>
          </header>

          <form className="off-content row">
            {typeof localVoucherLogin.id === "undefined" ? (
              <>
                {/* <ComboSelect
                        label={t('usergroups', null, 'capital')+' '+t('which will be used for temporary user')}
                        onClickedHandler={onMembershipTypeSearchClicked}
                        onRemoveHandler={onMembershipTypeRemove}
                        onItemSearchChanged={onMembershipTypeSearchChanged}
                        onItemSearchBlur={onMembershipTypeSearchBlur}
                        itemResultsHidden={membershipTypesResultsHidden}
                        onItemsSelectHandle={onMembershipTypesSelectHandle}
                        selectedItems={selectedUserGroups}
                        allItems={membershipTypesResults}
                        valkey={'id'}
                        valprop={'name'}/>*/}
                <div
                  id="VoucherCreateDialogValidity"
                  className="inb-c-item inb-c-item-validity medium-12 small-12 row"
                  key="validity"
                  style={{ paddingLeft: "30px" }}
                >
                  <MembershipTypeSelect
                    membershipTypes={selectedUserGroups}
                    setMembershipTypes={setSelectedUserGroups}
                    dispatch={dispatch}
                  />
                  <div className="medium-6 small-12 column float-left">
                    <label style={{ float: "left" }}>{t("valid_from_date")}</label>
                    <DatePicker
                      key={"inb-form-item-" + Math.floor(Math.random() * 10000)}
                      className="noBorders-noBackground text-right"
                      dateFormat="dd.MM.y"
                      selected={selectedBegin}
                      onChange={(date) => onChangeHandler(date)}
                      onKeyDown={(e) => {
                        if (e.keyCode === 8) e.preventDefault();
                      }}
                      placeholderText=""
                      locale={dateLocale}
                      style={{ float: "left", width: "50%" }}
                    />
                  </div>
                  <div className="medium-6 small-12 column">
                    <TimeInput
                      name="validPeriod"
                      label={t("validPeriod")}
                      unit="seconds"
                      value={timeInput}
                      onChange={onChange}
                    />
                  </div>
                  <div
                    className="medium-4 small-12 column"
                    title={t("user", null, "capital")}
                    style={{ minWidth: "90px" }}
                  >
                    <a
                      className={"button beautify beautify-" + Biscuit.get("user.client_id")}
                      href="#"
                      onClick={onGetQRCodeHandler}
                    >
                      <i className="fi fi-page-add"></i>
                      <span>{t("create", null, "capital")}</span>
                    </a>
                  </div>
                </div>
              </>
            ) : (
              <></>
            )}
          </form>
        </div>
      )}
    </>
  );
};

export default ItemLoginView;
